import React from 'react';
import { oneOfType, string, number } from 'prop-types';
import Blocked from './assets/Blocked.svg.js';
import Computer from './assets/Computer.svg.js';
import Abduction from './assets/Abduction.svg.js';
import Maintenance from './assets/Maintenance.svg.js';
export const FATAL_ERROR_NOTICE_TYPES = {
    BAD_REQUEST: '400',
    FORBIDDEN: '403',
    NOT_FOUND: '404',
    INTERNAL_SERVER_ERROR: '500',
    MAINTENANCE: '503',
};
const FatalErrorNoticeIcon = (props) => {
    const { type } = props;
    switch (String(type)) {
        case FATAL_ERROR_NOTICE_TYPES.NOT_FOUND:
            return React.createElement(Abduction, { "aria-hidden": 'true' });
        case FATAL_ERROR_NOTICE_TYPES.BAD_REQUEST:
        case FATAL_ERROR_NOTICE_TYPES.INTERNAL_SERVER_ERROR:
            return React.createElement(Computer, { "aria-hidden": 'true' });
        case FATAL_ERROR_NOTICE_TYPES.MAINTENANCE:
            return React.createElement(Maintenance, { "aria-hidden": 'true' });
        default:
            return React.createElement(Blocked, { "aria-hidden": 'true' });
    }
};
FatalErrorNoticeIcon.propTypes = {
    type: oneOfType([string, number]),
};
export default FatalErrorNoticeIcon;
//# sourceMappingURL=FatalErrorNoticeIcon.js.map